import { newDiv, createImage, prepareEvent } from '../RenderUtils';
import { addAnalyticsAttribute } from '../../../helpers/analytics';
import { CONTROLS_EVENTS_GA } from './Constants';
import { checkIsValidCurrentValue, checkIsValidVariants } from './checkIsValid';

const TIME = {
  MORNING: '7:00',
  DAY: '14:00',
  EVENING: '20:00',
};

const IMAGE = {
  [TIME.MORNING]: createImage('/images/map/morning.svg'),
  [TIME.DAY]: createImage('/images/map/day.svg'),
  [TIME.EVENING]: createImage('/images/map/evening.svg'),
};

const TIME_TO_GA_EVENT = {
  [TIME.MORNING]: CONTROLS_EVENTS_GA.TIME_MORNING,
  [TIME.DAY]: CONTROLS_EVENTS_GA.TIME_DAY,
  [TIME.EVENING]: CONTROLS_EVENTS_GA.TIME_EVENING,
};

export class TimeControl {
  static isConfigurationValid = ({ current, variants }) => {
    const expectedVariants = Object.values(TIME);
    const isValidCurrentValue = checkIsValidCurrentValue({
      current,
      expectedVariants,
      name: 'time',
    });
    const isValidVariants = checkIsValidVariants({ variants, expectedVariants, name: 'time' });

    return isValidCurrentValue && isValidVariants;
  };

  constructor(container, controlSetup, parentIframe) {
    this.container = container;
    this.controlSetup = controlSetup;
    this.parentIframe = parentIframe;
  }

  render() {
    const control = newDiv(null, this.container);
    const classControl = 'TimeControl';

    this.controlSetup.element = control;
    this.controlSetup.element.classList.add(classControl);

    const activateOption = (value, element) => {
      if (value === this.controlSetup.current) return;
      this.controlSetup.current = value;
      this.controlSetup.currentElement.classList.remove('-active');
      this.controlSetup.currentElement = element;
      this.controlSetup.currentElement.classList.add('-active');

      this.parentIframe.postMessage(
        {
          type: 'buttons',
          action: 'option',
          name: this.controlSetup.name,
          value,
        },
        '*',
      );
    };

    for (let j = 0; j < this.controlSetup.variants.length; j += 1) {
      const value = this.controlSetup.variants[j];
      const classOption = 'TimeControl-option';
      const content = IMAGE[value];

      const option = newDiv(content, this.controlSetup.element);
      option.classList.add(classOption);

      const gaEvent = TIME_TO_GA_EVENT[value];
      if (gaEvent) {
        addAnalyticsAttribute(option, gaEvent);
      }

      if (value === this.controlSetup.current) {
        option.classList.add('-active');
        this.controlSetup.currentElement = option;
      }

      option.addEventListener(
        'click',
        (e) => {
          prepareEvent(e);
          activateOption(value, option);
        },
        false,
      );

      this.controlSetup.variants[j] = {
        value,
        element: option,
        activate: activateOption,
      };
    }
  }
}
